import React from "react";
import { StockCheckExtract } from "../../interfaces/Sce";
import { ReactComponent as SaveIcon } from "../../assets/icons/save-icon.svg?react";
import { ReactComponent as GroupIcon } from "../../assets/icons/group-stock.svg?react";

interface SCECardProperties {
  sce: StockCheckExtract;
  cardClicked(): void;
}

const StockCheckCard = (props: SCECardProperties) => {
  function isUpdatedValidDate() {
    if (props.sce.updated) {
      if (!(props.sce.updated.toString() == "0001-01-01T00:00:00")) {
        return true;
      }
    }
    return false;
  }

  return (
    <div
      id={"stockcheck-card-" + Number(props.sce.stockCheckExtractRef)}
      className={
        "stockcheck-card" +
        (props.sce.cmsPicAct == "DateStampGroup" && !props.sce.groupOverride
          ? " group"
          : "")
      }
      onClick={() => {
        props.cardClicked();
      }}
    >
      <div className="stockcheck-card-top">
        <div className="stockcheck-card-title">
          {props.sce.cmsPicAct == "DateStampGroup" &&
          !props.sce.groupOverride ? (
            <GroupIcon
              className="type-icon"
              id={props.sce.stockCheckExtractRef + "-group-icon"}
            ></GroupIcon>
          ) : null}
          <span>
            {props.sce.stockCheckExtractRef
              ? Number(props.sce.stockCheckExtractRef)
              : "No Title"}
          </span>
          {props.sce.hasSavedData ? (
            <SaveIcon className="priorSavedData-icon" />
          ) : (
            ""
          )}
        </div>
        <span className="stockcheck-card-desc">
          {props.sce.stockCheckExtractDesc
            ? props.sce.stockCheckExtractDesc.toUpperCase()
            : "No Description"}
        </span>
      </div>
      <div className="stockcheck-card-bottom">
        {props.sce.cmsPicAct == "DateStampGroup" && !props.sce.groupOverride ? (
          <p>This is a Group Stock Check, please process it on Gold.</p>
        ) : (
          <>
            <span>Lines: {props.sce.totalLines}</span>
            <span>Submitted: {props.sce.linesCounted}</span>
            <span>
              Created: {new Date(props.sce.created).toLocaleDateString("en-GB")}
            </span>
            <span>
              Updated:{" "}
              {props.sce.updated && isUpdatedValidDate()
                ? new Date(props.sce.updated).toLocaleDateString("en-GB")
                : "Not Started"}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default StockCheckCard;
